import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export async function searchPolymarketTrades(query) {
  const url = `${backendUrl}/api/polymarket/trades/search/?q=${encodeURIComponent(query)}`;

  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при поиске сделок Polymarket');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API searchPolymarketTrades error:', error);
    throw error;
  }
}